import React from 'react'
import { TrendsLayout } from '../Trends/TrendsLayout'

function Trends() {
  return (
    <>
        <TrendsLayout />
    </>
  )
}

export default Trends
